import { rootApiSupplyBeam } from "../../api/rootApi";

export const checkoutListAPI = rootApiSupplyBeam.injectEndpoints({
  endpoints: (builder) => ({
    getCheckoutListData: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/data/checkoutList`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.data,
        };
      },
    }),
    getCheckoutInfoData: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/data/checkoutInfo`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    getCurrentLocationOfQr: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/data/getCurrentLocationOfQr`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    getBontonQrLocation: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/bonton/get-qr-location`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
  }),
});

export const {
  useGetCheckoutListDataMutation,
  useGetCheckoutInfoDataMutation,
  useGetCurrentLocationOfQrMutation,
  useGetBontonQrLocationMutation,
} = checkoutListAPI;
